import React from "react";

const Footer = () => {
  return (
    <footer>
      <a
        href="https://github.com/dBish6/React_Calculator_App"
        target="_blank"
        rel="noopener noreferrer"
      >
        GitHub Repository
      </a>

      <p>
        <b>Developer:</b> David Bishop
      </p>
    </footer>
  );
};

export default Footer;
